/**
 * ISSUE #47 FIX 3.47.7: ExamComponent Styles
 * Extracted styles for the exam component
 */

export const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  examModal: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    width: "90%",
    maxWidth: "900px",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
  },
  examHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px",
    borderBottom: "1px solid #eee",
  },
  examTitle: {
    margin: 0,
    fontSize: "20px",
  },
  examMeta: {
    margin: "4px 0 0 0",
    fontSize: "12px",
    color: "#666",
  },
  timerSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 16px",
    backgroundColor: "#f7f7f7",
    borderRadius: "8px",
  },
  timerIcon: {
    fontSize: "16px",
  },
  timer: {
    fontSize: "18px",
    fontWeight: "bold",
    minWidth: "50px",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#666",
    marginLeft: "16px",
  },
  progressBar: {
    height: "4px",
    backgroundColor: "#eee",
  },
  progressFill: {
    height: "100%",
    backgroundColor: "#007bff",
    transition: "width 0.3s",
  },
  questionsContainer: {
    flex: 1,
    overflowY: "auto",
    padding: "20px",
  },
  questionCard: {
    marginBottom: "20px",
    padding: "16px",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    border: "1px solid #eee",
  },
  questionCardError: {
    backgroundColor: "#fff3cd",
    borderColor: "#ffc107",
  },
  questionHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "12px",
  },
  questionNumber: {
    display: "inline-block",
    minWidth: "32px",
    padding: "4px 8px",
    backgroundColor: "#007bff",
    color: "#fff",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  questionText: {
    flex: 1,
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },
  optionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  optionLabel: {
    display: "flex",
    alignItems: "center",
    padding: "10px 12px",
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  optionLabelSelected: {
    backgroundColor: "#e3f2fd",
    borderColor: "#007bff",
    fontWeight: "500",
  },
  radioInput: {
    marginRight: "8px",
  },
  optionText: {
    fontSize: "13px",
    color: "#333",
  },
  validationError: {
    padding: "12px 20px",
    backgroundColor: "#fff3cd",
    color: "#856404",
    borderTop: "1px solid #eee",
    fontSize: "13px",
  },
  errorMessage: {
    padding: "12px 20px",
    backgroundColor: "#f8d7da",
    color: "#721c24",
    borderTop: "1px solid #eee",
    fontSize: "13px",
  },
  submittingMessage: {
    padding: "12px 20px",
    backgroundColor: "#d1ecf1",
    color: "#0c5460",
    borderTop: "1px solid #eee",
    fontSize: "13px",
  },
  examFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "12px",
    padding: "16px 20px",
    borderTop: "1px solid #eee",
    backgroundColor: "#f9f9f9",
  },
  examFooterNav: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  navButton: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "10px 16px",
    backgroundColor: "#fff",
    color: "#334155",
    border: "1px solid #cbd5e1",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "13px",
  },
  navButtonDisabled: {
    opacity: 0.45,
    cursor: "not-allowed",
  },
  footerInfo: {
    fontSize: "13px",
    color: "#666",
  },
  submitButton: {
    display: "flex",
    alignItems: "center",
    padding: "10px 24px",
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
    transition: "all 0.2s",
  },
  submitButtonDisabled: {
    backgroundColor: "#ccc",
    cursor: "not-allowed",
  },
  startModal: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "32px 28px",
    maxWidth: "440px",
    width: "92%",
    boxShadow: "0 24px 48px rgba(15, 23, 42, 0.2)",
    border: "1px solid rgba(226, 232, 240, 0.9)",
  },
  startModalIconWrap: {
    width: "56px",
    height: "56px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
  },
  startModalIcon: {
    fontSize: "26px",
    color: "#fff",
  },
  startModalTitle: {
    margin: "0 0 6px 0",
    fontSize: "1.35rem",
    fontWeight: 700,
    color: "#0f172a",
    letterSpacing: "-0.02em",
  },
  startModalSubtitle: {
    margin: "0 0 20px 0",
    fontSize: "0.95rem",
    color: "#64748b",
    lineHeight: 1.45,
  },
  examInfo: {
    backgroundColor: "#f8fafc",
    padding: "4px 0",
    borderRadius: "12px",
    margin: "12px 0 16px",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
  },
  examInfoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
    borderBottom: "1px solid #e2e8f0",
    fontSize: "0.875rem",
  },
  examInfoLabel: {
    color: "#64748b",
    fontWeight: 500,
  },
  examInfoValue: {
    color: "#0f172a",
    fontWeight: 600,
    textAlign: "right",
    maxWidth: "58%",
  },
  warningText: {
    color: "#b45309",
    fontSize: "0.8rem",
    fontWeight: 500,
    lineHeight: 1.5,
    margin: "0 0 8px 0",
    padding: "10px 12px",
    backgroundColor: "#fffbeb",
    borderRadius: "8px",
    border: "1px solid #fde68a",
  },
  startModalFooter: {
    display: "flex",
    gap: "12px",
    marginTop: "24px",
  },
  cancelButton: {
    flex: 1,
    padding: "12px 14px",
    border: "1px solid #cbd5e1",
    borderRadius: "10px",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "0.9rem",
    color: "#475569",
  },
  startButton: {
    flex: 1,
    padding: "12px 14px",
    background: "linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: 700,
    fontSize: "0.9rem",
    boxShadow: "0 4px 14px rgba(79, 70, 229, 0.35)",
  },
  completedModal: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px",
    maxWidth: "500px",
    textAlign: "center",
    boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
  },
  completedIcon: {
    fontSize: "48px",
    color: "#28a745",
    marginBottom: "16px",
  },
  resultsInfo: {
    backgroundColor: "#f0f0f0",
    padding: "16px",
    borderRadius: "8px",
    margin: "20px 0",
    textAlign: "left",
  },
  continueButton: {
    padding: "12px 32px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    marginTop: "20px",
  },
};
